import React from 'react';
import { motion } from 'framer-motion';
import './FloatingBadges.css';

const BADGES = [
  { id: 1, text: '💎', left: '10%' },
  { id: 2, text: '🔥', left: '28%' },
  { id: 3, text: '❤️', left: '46%' },
  { id: 4, text: '✨', left: '64%' },
  { id: 5, text: '🔔', left: '82%' },
];

export default function FloatingBadges() {
  return (
    <div className="floating-badges" aria-hidden>
      {BADGES.map((b, i) => (
        <motion.div
          key={b.id}
          className="floating-badge"
          initial={{ y: 0, opacity: 0 }}
          animate={{ y: -120 - (i * 20), opacity: [0.0, 0.9, 0.6] }}
          transition={{
            repeat: Infinity,
            repeatType: 'reverse',
            duration: 4 + i * 0.6,
            delay: i * 0.5,
            ease: 'easeInOut'
          }}
          style={{ left: b.left }}
        >
          <span className="badge-inner">{b.text}</span>
        </motion.div>
      ))}
    </div>
  );
}
